/**
 * SOFSEK — External-system attributes on the platform role record.
 *
 * A role is a role: migration 20260901000000 folded `sfk_external_role` into
 * `csm_role_master`, leaving only the two attributes the platform record has no
 * home for on the 1:1 sister `sfk_role` — which external system the role governs
 * (`application_id`, NULL for the platform's own roles) and the role's code in
 * that system (`external_ref`). A role's actions/permissions are the ONE unified
 * csm_role_page_access matrix (platform screens and external functions alike),
 * edited on the inherited Roles page — see 20260901000000.
 *
 * This manifest is what makes the single Roles screen show those attributes
 * without SOFSEK forking the inherited page (§16): the platform renders them as
 * grid columns / facets and saves them alongside the role. It replaces the old
 * SOFSEK-owned SFK.ROLE.LIST page, which is retired in the same change.
 *
 * Why a sister table and not DSE shadow-fields (§10): `application_id` is a real
 * FK, and external roles are matched back to `external_ref` on re-ingestion.
 */
import { registerRecordExtension } from '../../lib/record_extensions';

registerRecordExtension({
  key: 'sfk_role',
  page_code: 'CSM.ROLE.LIST',
  entity: 'csm_role_master',
  sister: { table: 'sfk_role', pk: 'role_id' },
  section_label_key: 'sfk.role.section',
  section_label_default: 'External Role',
  fields: [
    {
      // The external system this role governs (NULL = a platform / self role).
      key: 'application_id',
      label_key: 'sfk.role.application',
      label_default: 'Application',
      kind: 'fk',
      ref: { table: 'csm_application_master', pk: 'application_id', label_column: 'internal_code' },
      grid: true,
      grid_width: 150,
      facet: true,
    },
    {
      // The role's own code in that external system (blank for platform roles).
      key: 'external_ref',
      label_key: 'sfk.role.external_ref',
      label_default: 'External Code',
      kind: 'text',
      grid: true,
      grid_width: 140,
    },
  ],
});
